var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M5 8.75C5 12.2017 7.79825 15 11.25 15C14.7018 15 17.5 12.2017 17.5 8.75C17.5 5.29822 14.7018 2.5 11.25 2.5C7.79825 2.5 5 5.29822 5 8.75Z",
    fill: "#402864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 9.375C17.5 5.57804 14.422 2.5 10.625 2.5C6.82807 2.5 3.75 5.57804 3.75 9.375C3.75 11.0484 4.3479 12.5822 5.34172 13.7744L2.26639 16.8497C2.02231 17.0938 2.02231 17.4895 2.26639 17.7336C2.51047 17.9777 2.9062 17.9777 3.15028 17.7336L6.2256 14.6583C7.41779 15.6521 8.95158 16.25 10.625 16.25C14.422 16.25 17.5 13.1719 17.5 9.375ZM10.625 3.75C13.7316 3.75 16.25 6.26839 16.25 9.375C16.25 12.4816 13.7316 15 10.625 15C7.51843 15 5 12.4816 5 9.375C5 6.2684 7.51842 3.75 10.625 3.75Z",
    fill: "#402864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5c21429352e2abb83deae900034ca071.svg";
export { ForwardRef as ReactComponent };